export default {
  QUEST_ONBOARDING_QUESTID: 'c-greta-onboarding',
  GET_STARTED_QUESTID: 'c-greta-get-started',
  QUEST_FEEDBACK_QUESTID: 'c-greta-feedback-workflow',
  USER_ID: 'u-6ae7c6a4-0629-46f5-af15-77d15ec50e1c',
  APIKEY: 'k-967b7d78-06b4-4237-b120-275167e98262',
  TOKEN: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJ1LTZhZTdjNmE0LTA2MjktNDZmNS1hZjE1LTc3ZDE1ZWM1MGUxYyIsImlhdCI6MTc1MTE2MDE0NiwiZXhwIjoxNzUzNzUyMTQ2fQ.eGaM9GUQHkx0TMDD_2sDZh3bXRmyNvhJn3jpxl4iDwg',
  ENTITYID: 'e-d3b44de7-d03f-4153-b629-978ddaef9002',
  PRIMARY_COLOR: '#0ea5e9' // Extracted from your existing primary-500 color
};